export const FORM_REQUIRED_FIELD_ERROR = "This field is required.";

export const GENERIC_TOAST_ERROR_MESSAGE = "Something went wrong...";

export const GENERIC_TOAST_SAVED_MESSAGE = "Saved!";

export const GENERIC_TOAST_DELETED_MESSAGE = "Deleted!";

export const DG_MIXED_PACKAGES_ERROR =
  "FedEx does not allow dangerous goods and non-dangerous goods packages in the same booking. Switch Package Restricted on for every package, or send the non-DG packages as a separate shipment.";
